import { type Stop } from '../domain/Shipment'

type CheckState = 'is-previous' | 'is-current'

export type StopState = {
  index: number
  checkIn?: CheckState
  checkOut?: CheckState
}

export type TimelineStop = Pick<Stop, 'checkInAt' | 'checkOutAt'>

function getCheckInState(
  currentStop: TimelineStop,
  lastStop: TimelineStop
): CheckState | undefined {
  if (currentStop.checkInAt && !currentStop.checkOutAt) {
    return 'is-current'
  }

  if (!currentStop.checkInAt && lastStop.checkInAt) {
    return 'is-previous'
  }

  if (currentStop.checkOutAt) {
    return 'is-previous'
  }

  if (lastStop.checkOutAt) {
    return 'is-previous'
  }

  return undefined
}

type GetCheckoutStateParams = {
  currentStop: TimelineStop
  nextStop: TimelineStop
  lastStop: TimelineStop
  isLastStop: boolean
}

function getCheckOutState({
  currentStop,
  nextStop,
  lastStop,
  isLastStop,
}: GetCheckoutStateParams): CheckState | undefined {
  if (!isLastStop && nextStop.checkInAt) {
    return 'is-previous'
  }

  if (isLastStop && currentStop.checkOutAt) {
    return 'is-previous'
  }

  if (lastStop.checkOutAt) {
    return 'is-previous'
  }

  if (currentStop.checkOutAt) {
    return 'is-current'
  }

  return undefined
}

export function getTimelineStates(stops: TimelineStop[]) {
  return stops.map((stop, index) => {
    const lastStop = stops[stops.length - 1]
    const nextStop = stops[index + 1]
    const isLastStop = index === stops.length - 1

    return {
      index,
      checkIn: getCheckInState(stop, lastStop),
      checkOut: getCheckOutState({ currentStop: stop, lastStop, nextStop, isLastStop }),
    }
  })
}
